import { ACCENTS, accentVar } from "@codeshare/theme";
import { type FormEvent, useRef, useState } from "react";
import { getIdentityStore } from "../session/identity";
import { useIdentity } from "../session/use-identity";
import { Avatar } from "./Avatar";
import { closeOnBackdrop } from "./dialog";

/** Your name and color (shown to collaborators); click to edit. */
export function ProfileButton() {
  const identity = useIdentity();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [name, setName] = useState(identity.name);
  const [color, setColor] = useState(identity.color);

  const open = () => {
    setName(identity.name);
    setColor(identity.color);
    dialogRef.current?.showModal();
  };

  const save = (event: FormEvent) => {
    event.preventDefault();
    getIdentityStore().update({ name, color });
    dialogRef.current?.close();
  };

  return (
    <>
      <button
        type="button"
        id="open-profile"
        className="activity-item"
        onClick={open}
        title="Your name and color"
      >
        <Avatar name={identity.name} color={identity.color} />
        <span className="visually-hidden">{identity.name}</span>
      </button>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: Escape closes dialogs natively; this only adds backdrop clicks for the mouse */}
      <dialog
        ref={dialogRef}
        onClick={closeOnBackdrop}
        className="dialog"
        aria-label="Your profile"
      >
        <form onSubmit={save}>
          <h2>Your profile</h2>
          <label>
            Display name
            <input
              value={name}
              maxLength={40}
              required
              autoFocus
              onChange={(e) => setName(e.target.value)}
            />
          </label>
          <fieldset className="swatches">
            <legend>Color</legend>
            {ACCENTS.map((accent) => (
              <label key={accent} className="swatch" title={accent}>
                <input
                  type="radio"
                  name="color"
                  value={accent}
                  aria-label={accent}
                  checked={color === accent}
                  onChange={() => setColor(accent)}
                />
                <span style={{ background: accentVar(accent) }} />
              </label>
            ))}
          </fieldset>
          <div className="dialog-actions">
            <button type="button" onClick={() => dialogRef.current?.close()}>
              Cancel
            </button>
            <button type="submit" className="primary">
              Save
            </button>
          </div>
        </form>
      </dialog>
    </>
  );
}
